var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"connection"},[_c('div',{staticClass:"state"},[_c('div',{staticClass:"wrapper-process"},[_c('div',{staticClass:"show-process"},[_c('div',{staticClass:"processing"})])]),_c('div',{staticClass:"text"},[_vm._v(" Conectando... ")])])])
}]

export { render, staticRenderFns }